import config from '../../config/App_data';
import GetData from '../../RestAPI/getDataService';
import postData from '../../RestAPI/fetchData';

const getUserPerformanceBarGraph = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/dashboard/user-bar-graph`, data);
};
const getTotalUsersPerformanceBarGraph = async (data = {}) => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/frm/dashboard/all-user-bar-graph`,
    data,
  );
};
const sendFurtherHelpRequest = async (data = {}) => {
  return await postData.callAPI(`${config.backend_api}/contact_us/sendReportHelpRequest`, data);
};
const fetchQuestionProgressBar = async (data = {}) => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/frm/dashboard/question-progress-bar`,
    data,
  );
};
const fetchNotesProgressBar = async (data = {}) => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/frm/dashboard/notes-progress-bar`,
    data,
  );
};
//* QUESTION SAVE AND REPORT STARTED HERE
const fetchSavedQuestion = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/dashboard/saved-question`, data);
};
const fetchReportedQuestion = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/dashboard/reported-question`, data);
};
const deleteReportedQuestion = async (data) => {
  return await postData.callAPI(
    `${config.backend_api}/frm_question_bank/deleteDashboardQuestionReports`,
    { reports: data },
  );
};
const updateReportedQuestion = async (data) => {
  return await postData.callAPI(
    `${config.backend_api}/frm_question_bank/UpdateReportsQuestionsbyuserid`,
    {
      quesReport: data.comment,
      id: data.id,
    },
  );
};

const deleteSavedQuestion = async (data) => {
  return await postData.callAPI(`${config.backend_api}/frm_question_bank/deleteSavequestion`, {
    save_question: data,
  });
};
//* NOTES SAVE AND REPORT STARTED HERE
const fetchSavedNotes = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/dashboard/saved-notes`, data);
};
const fetchReportedNotes = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/dashboard/reported-notes`, data);
};
const deleteSavedNotes = async (data) => {
  return await postData.callAPI(`${config.backend_api}/frm_notes/deleteSaveNotes`, {
    save_question: data,
  });
};
const deleteReportedNotes = async (data) => {
  return await postData.callAPI(`${config.backend_api}/frm_notes/deleteDashboardNotesReports`, {
    reports: data,
  });
};
const updateReportedNotes = async (data) => {
  return await postData.callAPI(`${config.backend_api}/frm_notes/UpdateReportsNotesbyuserid`, {
    notesReport: data.comment,
    id: data.id,
  });
};

//* VIDEOS SAVE AND REPORT STARTED HERE
const fetchSavedVideos = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/dashboard/saved-videos`, data);
};
const fetchReportedVideos = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/dashboard/reported-videos`, data);
};
const deleteSavedVideo = async (data) => {
  return await postData.callAPI(`${config.backend_api}/frm_question_bank/deleteSaveVideo`, {
    save_question: data,
  });
};
const deleteReportedVideo = async (data) => {
  return await postData.callAPI(
    `${config.backend_api}/frm_question_bank/deleteDashboardVideoReports`,
    { reports: data },
  );
};
const updateReportedVideo = async (data) => {
  return await postData.callAPI(
    `${config.backend_api}/frm_question_bank/UpdateReportsVideobyuserid`,
    {
      videoReport: data.comment,
      id: data.id,
      level: data.level,
    },
  );
};

//* CBT SAVE AND REPORT STARTED HERE
const fetchCBTReportedQuestion = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/dashboard/reported-mocks`, data);
};
// redirectToCBTQuestion
const deleteCBTReportedQuestion = async (data) => {
  return await postData.callAPI(`${config.backend_api}/frmCBTMockExams/deleteReport`, {
    reports: data,
  });
};
const updateReportedCBTQuestion = async (data) => {
  return await postData.callAPI(`${config.backend_api}/frmCBTMockExams/updateReport`, {
    quesReport: data.comment,
    id: data.id,
    level: data.level,
  });
};

const deleteFlashCard = async (data = {}) => {
  return await postData.callAPI(`${config.backend_api}/question_bank_2024/deleteFlashCard`, data);
};
const redirectToCBTQuestion = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/dashboard/redirect-mocks`, data);
};
module.exports = {
  getUserPerformanceBarGraph,
  getTotalUsersPerformanceBarGraph,
  fetchQuestionProgressBar,
  fetchNotesProgressBar,
  fetchSavedQuestion,
  deleteSavedQuestion,
  deleteFlashCard,
  fetchReportedQuestion,
  deleteReportedQuestion,
  updateReportedQuestion,
  fetchSavedNotes,
  fetchReportedNotes,
  deleteSavedNotes,
  sendFurtherHelpRequest,
  deleteReportedNotes,
  updateReportedNotes,
  fetchSavedVideos,
  fetchReportedVideos,
  deleteSavedVideo,
  deleteReportedVideo,
  updateReportedVideo,
  fetchCBTReportedQuestion,
  deleteCBTReportedQuestion,
  updateReportedCBTQuestion,
  redirectToCBTQuestion,
};



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Dashboard/ApiService.js